import { DatePipe } from "@angular/common";
import { Injectable } from "@angular/core";
import { AccountActivationStage, EnumHelper, HorizontalListData, HorizontalListFactory, LoanStatus } from "common";
import { AccountWithRenewalData } from "../account.model";
import { AccountProfileStatusWidgetData } from "./account-profile-status-widget.component";

@Injectable()
export class AccountProfileStatusWidgetAdapter {
  constructor(
    private readonly datePipe: DatePipe,
  ) { }

  adaptListData = (data: AccountProfileStatusWidgetData): HorizontalListData[] => {
    return [
      HorizontalListFactory.createKeyValueCustomValueTemplateItem({
        title: 'Status',
        customTemplateName: "statusValue"
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Frozen until',
        displayedValue: this.datePipe.transform(data?.account?.frozenUntil) || '-',
        isItemHidden: data?.account?.status !== LoanStatus.Frozen
      }),
      HorizontalListFactory.createKeyValueCustomValueTemplateItem({
        title: 'Delinquent status',
        customTemplateName: "delinquentStatusValue"
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Product type',
        displayedValue: data.account.productName
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Created on',
        displayedValue: this.datePipe.transform(data?.account?.createdOn) || '-',
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Activation stage',
        displayedValue: this.getActivationStage(data?.account?.activationStage),
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Activation date',
        displayedValue: this.datePipe.transform(data?.account?.activationDate) || '-',
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Stage change date',
        displayedValue: this.datePipe.transform(data?.account?.stageChangeDate) || '-',
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Agreement signature date',
        displayedValue: this.datePipe.transform(data?.account?.openedOn) || '-',
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Renewal date',
        displayedValue: this.datePipe.transform(data?.account?.renewalDate) || '-',
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Amortization start date',
        displayedValue: this.datePipe.transform(data?.account?.fullAmortizationStartDateUtc, "mediumDate") || '-',
      }),
      HorizontalListFactory.createKeyValueRouterLinkItem({
        title: 'Renewed by',
        displayedValue: data?.account?.renewedByLoanNumber,
        routerLink: `/account/${data?.account?.renewedBy}/profile`,
        isItemHidden: !data?.account?.renewedBy
      }),
      HorizontalListFactory.createKeyValueRouterLinkItem({
        title: 'Renewed for',
        displayedValue: data?.account?.renewalForLoanNumber,
        routerLink: `/account/${data?.account?.renewalFor}/profile`,
        isItemHidden: !data?.account?.renewalFor
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Maturity date',
        displayedValue: this.getMaturityDate(data?.account)
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Updated on',
        displayedValue: this.datePipe.transform(data?.account?.updatedOn) || '-',
      }),
    ]
  }

  private getActivationStage(activationStage: AccountActivationStage): string{
    return EnumHelper.getNameFromValue(AccountActivationStage, activationStage);
  }

  private getMaturityDate(account: AccountWithRenewalData): string{
    const date = this.datePipe.transform(account?.maturityDate) || '';
    const repaymentTerm = account?.repaymentTerm || '-';
    const monthLabel = account?.repaymentTerm === 1 ? 'month' : 'months';
    return `${date} - ${repaymentTerm} ${monthLabel}`;
  }
}